const REGION_CODES = {
  'Arica y Parinacota': 'AP',
  'Tarapacá': 'TA',
  'Antofagasta': 'AN',
  'Atacama': 'AT',
  'Coquimbo': 'CO',
  'Valparaíso': 'VS',
  'Región Metropolitana de Santiago': 'RM',
  "Libertador General Bernardo O'Higgins": 'LI',
  'Maule': 'ML',
  'Ñuble': 'NB',
  'Biobío': 'BI',
  'La Araucanía': 'AR',
  'Los Ríos': 'LR',
  'Los Lagos': 'LL',
  'Aysén': 'AI',
  'Magallanes y de la Antártica Chilena': 'MA',
};

const REGIONS = {
  'Arica y Parinacota': ['Arica', 'Camarones', 'Putre', 'General Lagos'],
  'Tarapacá': ['Iquique', 'Alto Hospicio', 'Pozo Almonte', 'Camiña', 'Colchane', 'Huara', 'Pica'],
  'Antofagasta': ['Antofagasta', 'Mejillones', 'Sierra Gorda', 'Taltal', 'Calama', 'Ollagüe', 'San Pedro de Atacama', 'Tocopilla', 'María Elena'],
  'Atacama': ['Copiapó', 'Caldera', 'Tierra Amarilla', 'Chañaral', 'Diego de Almagro', 'Vallenar', 'Alto del Carmen', 'Freirina', 'Huasco'],
  'Coquimbo': ['La Serena', 'Coquimbo', 'Andacollo', 'La Higuera', 'Paiguano', 'Vicuña', 'Illapel', 'Canela', 'Los Vilos', 'Salamanca', 'Ovalle', 'Combarbalá', 'Monte Patria', 'Punitaqui', 'Río Hurtado'],
  'Valparaíso': ['Valparaíso', 'Casablanca', 'Concón', 'Juan Fernández', 'Puchuncaví', 'Quintero', 'Viña del Mar', 'Isla de Pascua', 'Los Andes', 'Calle Larga', 'Rinconada', 'San Esteban', 'Quillota', 'La Calera', 'Hijuelas', 'La Cruz', 'Nogales', 'San Antonio', 'Algarrobo', 'Cartagena', 'El Quisco', 'El Tabo', 'Santo Domingo', 'San Felipe', 'Catemu', 'Llaillay', 'Panquehue', 'Putaendo', 'Santa María', 'Quilpué', 'Limache', 'Olmué', 'Villa Alemana'],
  'Región Metropolitana de Santiago': ['Santiago', 'Cerrillos', 'Cerro Navia', 'Conchalí', 'El Bosque', 'Estación Central', 'Huechuraba', 'Independencia', 'La Cisterna', 'La Florida', 'La Granja', 'La Pintana', 'La Reina', 'Las Condes', 'Lo Barnechea', 'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'Ñuñoa', 'Pedro Aguirre Cerda', 'Peñalolén', 'Providencia', 'Pudahuel', 'Quilicura', 'Quinta Normal', 'Recoleta', 'Renca', 'San Joaquín', 'San Miguel', 'San Ramón', 'Vitacura', 'Puente Alto', 'Pirque', 'San José de Maipo', 'Colina', 'Lampa', 'Tiltil', 'San Bernardo', 'Buin', 'Calera de Tango', 'Paine', 'Talagante', 'El Monte', 'Isla de Maipo', 'Padre Hurtado', 'Peñaflor', 'Melipilla', 'Alhué', 'Curacaví', 'María Pinto', 'San Pedro'],
  "Libertador General Bernardo O'Higgins": ['Rancagua', 'Codegua', 'Coinco', 'Coltauco', 'Doñihue', 'Graneros', 'Las Cabras', 'Machalí', 'Malloa', 'Mostazal', 'Olivar', 'Peumo', 'Pichidegua', 'Quinta de Tilcoco', 'Rengo', 'Requínoa', 'San Vicente', 'Pichilemu', 'La Estrella', 'Litueche', 'Marchihue', 'Navidad', 'Paredones', 'San Fernando', 'Chépica', 'Chimbarongo', 'Lolol', 'Nancagua', 'Palmilla', 'Peralillo', 'Placilla', 'Pumanque', 'Santa Cruz'],
  'Maule': ['Talca', 'Constitución', 'Curepto', 'Empedrado', 'Maule', 'Pelarco', 'Pencahue', 'Río Claro', 'San Clemente', 'San Rafael', 'Cauquenes', 'Chanco', 'Pelluhue', 'Curicó', 'Hualañé', 'Licantén', 'Molina', 'Rauco', 'Romeral', 'Sagrada Familia', 'Teno', 'Vichuquén', 'Linares', 'Colbún', 'Longaví', 'Parral', 'Retiro', 'San Javier', 'Villa Alegre', 'Yerbas Buenas'],
  'Ñuble': ['Chillán', 'Bulnes', 'Chillán Viejo', 'El Carmen', 'Pemuco', 'Pinto', 'Quillón', 'San Ignacio', 'Yungay', 'Quirihue', 'Cobquecura', 'Coelemu', 'Ninhue', 'Portezuelo', 'Ránquil', 'Treguaco', 'San Carlos', 'Coihueco', 'Ñiquén', 'San Fabián', 'San Nicolás'],
  'Biobío': ['Concepción', 'Coronel', 'Chiguayante', 'Florida', 'Hualqui', 'Lota', 'Penco', 'San Pedro de la Paz', 'Santa Juana', 'Talcahuano', 'Tomé', 'Hualpén', 'Lebu', 'Arauco', 'Cañete', 'Contulmo', 'Curanilahue', 'Los Álamos', 'Tirúa', 'Los Ángeles', 'Antuco', 'Cabrero', 'Laja', 'Mulchén', 'Nacimiento', 'Negrete', 'Quilaco', 'Quilleco', 'San Rosendo', 'Santa Bárbara', 'Tucapel', 'Yumbel', 'Alto Biobío'],
  'La Araucanía': ['Temuco', 'Carahue', 'Cunco', 'Curarrehue', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro', 'Loncoche', 'Melipeuco', 'Nueva Imperial', 'Padre Las Casas', 'Perquenco', 'Pitrufquén', 'Pucón', 'Saavedra', 'Teodoro Schmidt', 'Toltén', 'Vilcún', 'Villarrica', 'Cholchol', 'Angol', 'Collipulli', 'Curacautín', 'Ercilla', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Purén', 'Renaico', 'Traiguén', 'Victoria'],
  'Los Ríos': ['Valdivia', 'Corral', 'Lanco', 'Los Lagos', 'Máfil', 'Mariquina', 'Paillaco', 'Panguipulli', 'La Unión', 'Futrono', 'Lago Ranco', 'Río Bueno'],
  'Los Lagos': ['Puerto Montt', 'Calbuco', 'Cochamó', 'Fresia', 'Frutillar', 'Los Muermos', 'Llanquihue', 'Maullín', 'Puerto Varas', 'Castro', 'Ancud', 'Chonchi', 'Curaco de Vélez', 'Dalcahue', 'Puqueldón', 'Queilén', 'Quellón', 'Quemchi', 'Quinchao', 'Osorno', 'Puerto Octay', 'Purranque', 'Puyehue', 'Río Negro', 'San Juan de la Costa', 'San Pablo', 'Chaitén', 'Futaleufú', 'Hualaihué', 'Palena'],
  'Aysén': ['Coyhaique', 'Lago Verde', 'Aysén', 'Cisnes', 'Guaitecas', 'Cochrane', "O'Higgins", 'Tortel', 'Chile Chico', 'Río Ibáñez'],
  'Magallanes y de la Antártica Chilena': ['Punta Arenas', 'Laguna Blanca', 'Río Verde', 'San Gregorio', 'Cabo de Hornos', 'Antártica', 'Porvenir', 'Primavera', 'Timaukel', 'Natales', 'Torres del Paine'],
};

class MmgsmComunaGate extends HTMLElement {
  connectedCallback() {
    this.regionSelect = this.querySelector('[data-mmgsm-region-select]');
    this.comunaWrapper = this.querySelector('[data-mmgsm-comuna-wrapper]');
    this.comunaSelect = this.querySelector('[data-mmgsm-comuna-select]');
    this.message = this.querySelector('[data-mmgsm-comuna-message]');
    this.regionInput = this.querySelector('[data-mmgsm-region-input]');
    this.comunaInput = this.querySelector('[data-mmgsm-comuna-input]');

    if (!this.regionSelect || !this.comunaSelect) return;

    // El carrito puede reconectar este mismo elemento varias veces (ej. al
    // refrescar totales), y el propio botón de pago puede ser reemplazado por
    // uno nuevo en ese proceso. Por eso no guardamos una referencia fija al
    // botón: se busca fresca cada vez (ver getCheckoutButton/getAcceleratedButtons)
    // y el clic se escucha por delegación en document, no en el nodo puntual.
    if (!this._initialized) {
      this._initialized = true;

      // Intercepta el clic en "Pagar" (por delegación, para sobrevivir a que
      // el carrito reemplace el botón) para llevar la comuna elegida al campo
      // Ciudad del checkout (vía parámetros de URL, igual que hacen apps como
      // Selecty). Se usa "capture" para actuar antes que otros listeners del tema.
      document.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('.cart__checkout-button');
          if (button && this.parentElement?.contains(button)) {
            this.handleCheckoutClick(event);
          }
        },
        { capture: true }
      );

      this.regionSelect.addEventListener('change', () => this.handleRegionChange());
      this.comunaSelect.addEventListener('change', () => this.handleComunaChange());

      // Autorreparación: si algo (ej. un refresco/morph del carrito) borra
      // las opciones que agregamos por JS, las volvemos a poner.
      this._observer = new MutationObserver(() => this.syncState());
      this._observer.observe(this, { childList: true, subtree: true });
    }

    this.syncState();
  }

  getCheckoutButton() {
    return this.parentElement?.querySelector('.cart__checkout-button') || null;
  }

  getAcceleratedButtons() {
    return this.parentElement?.querySelector('.additional-checkout-buttons') || null;
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }

  // Re-sincroniza el DOM (opciones de región/comuna, visibilidad, bloqueo del
  // botón) con el estado actual, sin perder la selección ya hecha. Se llama
  // tanto al conectar como cada vez que el carrito reconecta este elemento.
  syncState() {
    // Vuelve a buscar los elementos por si el carrito reemplazó estos nodos
    // (no solo les vació el contenido) al refrescar totales.
    this.regionSelect = this.querySelector('[data-mmgsm-region-select]') || this.regionSelect;
    this.comunaWrapper = this.querySelector('[data-mmgsm-comuna-wrapper]') || this.comunaWrapper;
    this.comunaSelect = this.querySelector('[data-mmgsm-comuna-select]') || this.comunaSelect;
    this.message = this.querySelector('[data-mmgsm-comuna-message]') || this.message;
    this.regionInput = this.querySelector('[data-mmgsm-region-input]') || this.regionInput;
    this.comunaInput = this.querySelector('[data-mmgsm-comuna-input]') || this.comunaInput;

    if (!this.regionSelect || !this.comunaSelect) return;

    if (this.regionSelect.options.length <= 1) {
      this.populateRegions();
    }

    const region = this.regionSelect.value;

    if (region) {
      this.comunaWrapper.hidden = false;
      if (this.comunaSelect.options.length <= 1) {
        this.populateComunas(region);
      }
    } else {
      this.comunaWrapper.hidden = true;
    }

    const comuna = this.comunaSelect.value;
    if (this.regionInput) this.regionInput.value = region;
    if (this.comunaInput) this.comunaInput.value = comuna;

    if (comuna) {
      this.unlock();
    } else {
      this.lock();
    }
  }

  populateRegions() {
    const previousValue = this.regionSelect.value;
    this.regionSelect.innerHTML = '<option value="">Selecciona tu región...</option>';
    for (const regionName of Object.keys(REGIONS)) {
      const option = document.createElement('option');
      option.value = regionName;
      option.textContent = regionName;
      this.regionSelect.appendChild(option);
    }
    if (previousValue) this.regionSelect.value = previousValue;
  }

  populateComunas(regionName) {
    const previousValue = this.comunaSelect.value;
    this.comunaSelect.innerHTML = '<option value="">Selecciona tu comuna...</option>';
    const comunas = REGIONS[regionName] || [];
    for (const comuna of comunas) {
      const option = document.createElement('option');
      option.value = comuna;
      option.textContent = comuna;
      this.comunaSelect.appendChild(option);
    }
    if (previousValue && comunas.includes(previousValue)) {
      this.comunaSelect.value = previousValue;
    }
  }

  handleRegionChange() {
    const region = this.regionSelect.value;
    // Región cambiada explícitamente por el usuario: la comuna ya no aplica.
    this.comunaSelect.innerHTML = '<option value="">Selecciona tu comuna...</option>';
    this.setMessage('');

    if (region) {
      this.populateComunas(region);
    }

    this.syncState();
  }

  handleComunaChange() {
    this.setMessage(this.comunaSelect.value ? `Comuna seleccionada: ${this.comunaSelect.value}.` : '');
    this.syncState();
  }

  async handleCheckoutClick(event) {
    const region = this.regionSelect.value;
    const comuna = this.comunaSelect.value;

    if (!comuna) return; // el botón debería estar bloqueado en este caso igual

    event.preventDefault();
    event.stopImmediatePropagation();

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { Región: region, Comuna: comuna } }),
      });

      // El prellenado de dirección de Shopify solo funciona pasando por
      // /cart/{variante}:{cantidad},... con los parámetros checkout[...],
      // no navegando directo a /checkout.
      const cart = await (await fetch('/cart.js')).json();
      const permalink = cart.items.map((item) => `${item.variant_id}:${item.quantity}`).join(',');

      const params = new URLSearchParams();
      params.set('checkout[shipping_address][city]', comuna);
      params.set('checkout[shipping_address][province]', region);
      params.set('checkout[shipping_address][country]', 'Chile');

      window.location.href = `/cart/${permalink}?${params.toString()}`;
    } catch (e) {
      // Si algo falla, igual dejamos avanzar al checkout normal sin prellenado.
      window.location.href = '/checkout';
    }
  }

  setMessage(text) {
    if (this.message) this.message.textContent = text;
  }

  lock() {
    const button = this.getCheckoutButton();
    if (button) button.disabled = true;
    const accelerated = this.getAcceleratedButtons();
    if (accelerated) {
      accelerated.style.pointerEvents = 'none';
      accelerated.style.opacity = '0.5';
    }
  }

  unlock() {
    const button = this.getCheckoutButton();
    if (button) button.disabled = false;
    const accelerated = this.getAcceleratedButtons();
    if (accelerated) {
      accelerated.style.pointerEvents = '';
      accelerated.style.opacity = '';
    }
  }
}

if (!customElements.get('mmgsm-comuna-gate')) {
  customElements.define('mmgsm-comuna-gate', MmgsmComunaGate);
}
